export default "__VITE_ASSET__CAbot6Yn__"